<div
  class="scribe-review-dialog flex h-[80vh] flex-col overflow-hidden"
  data-testid="scribe-review-dialog"
>
  <!-- Toolbar -->
  <div
    class="flex items-center justify-between border-b border-slate-200 px-5 py-3.5"
  >
    <div class="flex items-center gap-3">
      <span
        class="bg-primary-50 text-primary-500 flex h-9 w-9 items-center justify-center rounded-md"
      >
        <mat-icon>auto_awesome</mat-icon>
      </span>
      <div class="flex flex-col gap-1">
        <h3 class="text-accent-500 !mb-0 text-base font-semibold">
          Scribe Notes — {{ patientName }}
        </h3>
        <p
          class="!mb-0 text-xs text-slate-500"
          data-testid="scribe-review-note-meta"
        >
          {{ noteDateLabel() }} • {{ practitionerName }}
        </p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      aria-label="Close"
      data-testid="scribe-review-close"
      (click)="dismiss()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (isLoading()) {
    <div
      class="flex flex-1 items-center justify-center p-10"
      data-testid="scribe-review-loading"
    >
      <mat-spinner [diameter]="32" />
    </div>
  } @else if (notes().length === 0) {
    <div
      class="flex flex-1 flex-col items-center justify-center gap-2 p-10 text-center"
      data-testid="scribe-review-empty"
    >
      <mat-icon class="text-slate-300">description</mat-icon>
      <p class="m-0 text-sm font-medium text-slate-400">
        No scribe notes for this day.
      </p>
    </div>
    <div
      class="flex items-center justify-end border-t border-slate-200 bg-slate-50 px-5 py-3.5"
    >
      <button
        mat-stroked-button
        type="button"
        data-testid="scribe-review-dismiss"
        (click)="dismiss()"
      >
        Dismiss
      </button>
    </div>
  } @else {
    <!-- Position strip: «N of M» with prev/next -->
    <div
      class="flex items-center justify-between border-b border-slate-200 bg-slate-50 px-5 py-2.5"
      data-testid="scribe-review-position-bar"
    >
      <div class="flex items-center gap-1.5">
        <button
          mat-icon-button
          type="button"
          aria-label="Previous note"
          data-testid="scribe-review-previous"
          [disabled]="!hasPrevious()"
          (click)="previous()"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span
          class="text-xs font-medium text-slate-600"
          data-testid="scribe-review-position"
        >
          {{ position() }} of {{ notes().length }}
        </span>
        <button
          mat-icon-button
          type="button"
          aria-label="Next note"
          data-testid="scribe-review-next"
          [disabled]="!hasNext()"
          (click)="next()"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      @if (isInserted()) {
        <span
          class="bg-success-500/10 text-success-500 flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium"
          data-testid="scribe-review-inserted-badge"
        >
          <mat-icon class="icon-xs">check</mat-icon>
          Inserted
        </span>
      }
    </div>

    <!-- Scribe note -->
    <div
      class="flex-1 overflow-y-auto p-5"
      data-testid="scribe-review-note-pane"
    >
      @if (noteContent(); as content) {
        <pr-content-view [content]="content" />
      }
    </div>

    <!-- Footer -->
    <div
      class="flex items-center justify-between border-t border-slate-200 bg-slate-50 px-5 py-3.5"
    >
      @switch (insertState()) {
        @case (insertStates.Locked) {
          <p class="text-warn-500 m-0 text-xs" data-testid="scribe-review-hint">
            This clinical note is locked
          </p>
        }
        @case (insertStates.NoChartTarget) {
          <p
            class="m-0 text-xs text-slate-400"
            data-testid="scribe-review-hint"
          >
            Open this patient's record for this day to insert
          </p>
        }
        @case (insertStates.AlreadyInserted) {
          <p
            class="text-success-500 m-0 flex items-center gap-1 text-xs font-medium"
            data-testid="scribe-review-hint"
          >
            <mat-icon class="icon-xs">check</mat-icon>
            Already inserted
          </p>
        }
        @default {
          <p
            class="m-0 text-xs text-slate-400"
            data-testid="scribe-review-hint"
          >
            Review before inserting into the clinical record.
          </p>
        }
      }

      <div class="flex items-center gap-2.5">
        <button
          mat-stroked-button
          type="button"
          data-testid="scribe-review-dismiss"
          (click)="dismiss()"
        >
          Dismiss
        </button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          data-testid="scribe-review-insert"
          [disabled]="!canInsert()"
          (click)="insert()"
        >
          @if (isInserted()) {
            {{ insertAgainLabel }}
          } @else {
            Insert
          }
        </button>
      </div>
    </div>
  }
</div>
